export enum UsuarioEmpresaStatus {
    Pendente = 'P',
    Ativo = 'A',
    Bloqueado = 'B',
}

export enum UsuarioPerfilTipoIdpk {
    Administrador = 1,
    Gerente = 2,
    Comprador = 3,
    Financeiro = 4,
    FinanceiroAvancado = 5,
    Vendedor = 6,
    VendedorAvancado = 7,
    AplicativoIntegrado = 8,
    Operador = 9,
}
